import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import Title from "../../Title/Title";
import { useFetch, usePOST } from "../../../ApiS";
import { Bounce, toast, ToastContainer } from "react-toastify";
import { useEffect, useRef, useState } from "react";
import Loader from "../../Loader";
import { AxiosError } from "axios";
import { Tooltip } from "react-tooltip";
import { FaCheck, FaEdit, FaTrash } from "react-icons/fa";

interface Discount {
  id?: number;
  name?: string;
  percentage?: string | undefined;
  is_exhausted_student?: 1 | 0;
}
interface Error {
  id?: string[];
  name?: string[];
  percentage?: string[];
  is_exhausted_student?: string[];
}

interface DiscountData {
  data: Discount;
}

const Create_New_Discount: React.FC = () => {
  const [errors, setErrors] = useState<Error>({});
  const [isEditing, setIsEditing] = useState(false);


  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const navigate = useNavigate();
  const { id, idd } = useParams();
  const enable = idd ? true : false;
  const { data, isLoading } = useFetch(
    `admin/semesters/${id}/discounts/${idd}`,
    `discounts/${idd}`,
    enable
  );

  const [disData, setDisData] = useState<Discount>({
    name: "",
    percentage: "",
    is_exhausted_student: 0,
  });

  const [dis, setDis] = useState<Discount[]>([]);

  const { handleSubmit, setFormData, mutation } = usePOST(
    {},
    () => {
      navigate(`/new_semester/${id}/discount`);
    },
    (error) => {
      onError(error);
    }
  );

  const prepareFormData = () => {
    const formattedOptions = dis.reduce((acc, dis, index) => {
      return {
        ...acc,
        [`discounts[${index}][name]`]: dis.name,
        [`discounts[${index}][percentage]`]: dis.percentage,
        [`discounts[${index}][is_exhausted_student]`]: dis.is_exhausted_student,
      };
    }, {});
    setFormData({
      ...formattedOptions,
    });
  };

  useEffect(() => {
    prepareFormData();
  }, [dis]);

  useEffect(() => {
    if (data?.data) {
      setDisData({
        name: data.data.name || "",
        percentage: data.data.percentage || "",
        is_exhausted_student: data.data.is_exhausted_student ?? 0,
      });
    }
  }, [data]);

  const [editIndex, setEditIndex] = useState<number | null>(null);

  const handleSave = () => {
    if (!disData?.name || !disData?.percentage) {
      toast.error("يرجى ملء جميع الحقول المطلوبة");
      return;
    }

    if (editIndex !== null) {
      const updateddis = [...dis];
      updateddis[editIndex] = { ...dis[editIndex], ...disData };
      setDis(updateddis);
      toast.success("تم التحديث بنجاح");
    } else {
      setDis((prev) => [...prev, disData]);
      toast.success("تم الحفظ بنجاح");
    }

    setDisData({
      name: "",
      percentage: "",
      is_exhausted_student: 0 || 1,
    });
    setEditIndex(null);
  };

  const handleEdit = (index: number) => {
    const discount = dis[index];
    if (discount) {
      setDisData(discount);
      setEditIndex(index);
    } else {
      console.error("Invalid index: No discount found at this index.");
    }
    setIsEditing(true);

  };

  const handleDelete = (index: number) => {
    const updateddis = dis.filter((_, i) => i !== index);
    setDis(updateddis);
    toast.success("تم الحذف بنجاح");
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDisData((prev) => ({
      ...prev,
      is_exhausted_student: e.target.checked ? 1 : 0,
    }));
  };

  const sumbit = () => {
    handleSubmit(
      idd
        ? `admin/semesters/${id}/discounts/${idd}`
        : `admin/semesters/${id}/discounts`
    );
  };

  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: idd ? "هناك خطأ في عملية التعديل" : "هناك خطأ في عملية الاضافة",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);

  const [PopUp, setPopUp] = useState(false);

  console.log(dis);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Row>
        <Col lg={4} md={4}>
          <Title title={idd ? "تعديل الخصومات" : "إنشاء الخصومات"} />
        </Col>
      </Row>
      <ToastContainer position="bottom-left" />
      <Row justify={"around"}>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="name"
            name="name"
            onChange={(e) =>
              setDisData((prev) => ({
                ...prev,
                name: e.target.value,
              }))
            }
            title="الأسم"
            placeholder="أدخل الاسم"
            className="!w-full"
            value={disData?.name || ""}
            defaultValue={disData?.name}
          />
          {errors?.name &&
            errors?.name.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="number"
            name="percentage"
            onChange={(e) =>
              setDisData((prev) => ({
                ...prev,
                percentage: e.target.value,
              }))
            }
            title="النسبة"
            placeholder="أدخل النسبة"
            className="!w-full"
            value={disData?.percentage || ""}
            defaultValue={disData?.percentage}
          />
          {errors?.percentage &&
            errors?.percentage.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={5} md={5} sm={11}>
          <div className="border-2 border-Main text-l flex items-center justify-center py-2 rounded-2xl gap-2 !w-[97%]">
            <input
              type="checkbox"
              onChange={handleCheckboxChange}
              name="is_exhausted_student"
              className="relative w-5 h-5"
              checked={disData?.is_exhausted_student === 1}
              defaultChecked={
                disData?.is_exhausted_student === 1 ? true : false
              }
            />
            <span className="text-xl font-bold text-yellow-700">
              هل الحسم صالح لاستخدامه من قبل الطلاب المستنفذين؟
            </span>
          </div>
          {errors?.is_exhausted_student &&
            errors?.is_exhausted_student.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>

        {dis?.length > 0 && (
          <Col lg={5} md={5} sm={11}>
            <div className="cursor-pointer underline text-red-600" onClick={() => setPopUp(true)}>عرض الخصومات المنشأة</div>
          </Col>
        )}
      </Row>
      <Col
        lg={11}
        md={5}
        sm={11}
        className="flex lg:justify-center max-lg:mx-auto !mt-4"
      >
        <MainButton
          onClick={handleSave}
          titlebtn="إنشاء"
          className={`w-[400px] ${idd ? "hidden" : ""}`}
        />
      </Col>
      <Col
        lg={11}
        md={5}
        sm={11}
        className="flex lg:justify-center max-lg:mx-auto !mt-4"
      >
        <MainButton
          onClick={sumbit}
          titlebtn="حفظ"
          className={`w-[400px] ${
            dis.length === 0 ? (idd ? "" : "hidden") : ""
          }`}
        />
      </Col>

      {PopUp === true && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh] w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold !bg-black !bg-opacity-50"
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full max-lg:h-[70%] max-lg:overflow-y-scroll bg-white p-5 border-2 rounded-xl"
            >
              <Col lg={12} className="flex justify-center !mt-2">
                <Title title="المقررات المدخلة" />
              </Col>

              {dis?.map((e, index) => (
                <>
                  <Col lg={10}>
                    <div className="flex justify-end">
                      <div id="Delete">
                        <FaTrash
                          size={25}
                          className="text-red-600 cursor-pointer hover:text-red-800 mx-10"
                          onClick={() => handleDelete(index)}
                        />
                      </div>
                      <div id="Edit">
                      {isEditing ? (
                              <FaCheck
                                size={25}
                                className="text-blue-600 cursor-pointer hover:text-green-800"
                              />
                            ) : (
                              <FaEdit
                                size={25}
                                className="text-blue-600 cursor-pointer hover:text-blue-800"
                                onClick={() => handleEdit(index)}
                              />
                            )}
                      </div>
                      <Tooltip
                        anchorSelect={`#Edit`}
                        style={{ background: "#475569" }}
                      >
                        <p>تمكين التعديل</p>
                      </Tooltip>
                      <Tooltip
                        anchorSelect={`#Delete`}
                        style={{ background: "#475569" }}
                      >
                        <p>حذف المقرر</p>
                      </Tooltip>
                    </div>
                  </Col>
                  <Col lg={5} md={5} sm={11}>
                    <Input
                      type="name"
                      name="name"
                      value={
                        editIndex === index ? disData.name || "" : e.name || ""
                      }
                      onChange={(event) =>
                        setDisData((prev) => ({
                          ...prev,
                          name: event.target.value,
                        }))
                      }
                      title="الأسم"
                      placeholder="أدخل الاسم"
                      className="!w-full"
                    />
                  </Col>
                  <Col lg={5} md={5} sm={11}>
                    <Input
                      type="number"
                      name="percentage"
                      value={
                        editIndex === index
                          ? disData.percentage || ""
                          : e.percentage || ""
                      }
                      onChange={(event) =>
                        setDisData((prev) => ({
                          ...prev,
                          percentage: event.target.value,
                        }))
                      }
                      title="النسبة"
                      placeholder="أدخل النسبة"
                      className="!w-full"
                    />
                  </Col>

                  <Col lg={10} md={5} sm={11}>
                    <div className="border-2 border-Main text-l flex items-center justify-center py-2 rounded-2xl gap-2 !w-[97%]">
                      <input
                        type="checkbox"
                        name="is_exhausted_student"
                        className="relative w-5 h-5"
                        checked={
                          editIndex === index
                            ? Boolean(disData.is_exhausted_student)
                            : Boolean(e.is_exhausted_student)
                        }
                        onChange={(event) =>
                          setDisData((prev) => ({
                            ...prev,
                            is_exhausted_student: event.target.checked ? 1 : 0,
                          }))
                        }
                      />
                      <span className="text-xl font-bold text-yellow-700">
                        هل الحسم صالح لاستخدامه من قبل الطلاب المستنفذين؟
                      </span>
                    </div>
                  </Col>
                </>
              ))}
              <Row justify="around">
                <Col lg={5} md={6} className="!mt-7">
                  <MainButton
                    onClick={handleSave}
                    titlebtn="تحديث"
                    className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                  />
                </Col>
                <Col
                  lg={5}
                  md={6}
                  className="!mt-7"
                  onClick={() => setEditIndex(null)}
                >
                  <MainButton
                    titlebtn="رجوع"
                    onClick={() => setPopUp(false)}
                    className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                  />
                </Col>
              </Row>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Create_New_Discount;
